import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { updateShipmentConfiguration } from '../../store/csw/csw.actions';

export const usePickupTimeState = (fulfillmentPlanId, onConfigurationChange) => {
  const dispatch = useDispatch();
  const onPickupChange = useCallback(
    (newPickupTime) => {
      onConfigurationChange({
        pickup: newPickupTime,
      });
      dispatch(
        updateShipmentConfiguration(fulfillmentPlanId, {
          pickup: newPickupTime,
        }),
      );
    },
    [dispatch, fulfillmentPlanId, onConfigurationChange],
  );

  return {
    onPickupChange,
  };
};
